import React from 'react'

import { WithContentfulPage } from '../components/WithContentfulPage'
import SignIn from '../containers/SignIn'
import { getPageProps } from '../utils/getPageProps'

const LoginPage = ({ pathname, previews}) => {
  return (
      <SignIn />
  )
}


export default WithContentfulPage(LoginPage)
